import { render, staticRenderFns } from "./ThOrderable.vue?vue&type=template&id=ac9cb666&"
import script from "./ThOrderable.vue?vue&type=script&lang=js&"
export * from "./ThOrderable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports